import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="enableable"
//
// Enables the enableable targets only while every source target meets the criteria —
// for example, keeping a form's submit button disabled until a comment has been
// typed. Wire whichever events can change a source's state as actions on the
// controller element:
//
//   data-controller="enableable"
//   data-action="lexxy:change->enableable#refresh input->enableable#refresh"
//   data-enableable-criteria-value="present" (the default)
//
// Render the enableable disabled: this runs on connect, but not before the markup is
// live, so a button served enabled can be clicked in between.
//
// Criteria:
//   present — the source holds a non-blank value. Understands the Lexxy editor
//             and any control that carries what it holds in `value`. An editor
//             that has not initialised yet counts as blank; its initialize event
//             refreshes the state once it is ready.
//
//             Checkboxes and radios are not covered: their `value` reads the
//             same whether or not they are checked, so they would always look
//             present. A criteria of their own would also have to say what a
//             group means, which `every` does not answer.
export default class extends Controller {
  static targets = ['source', 'enableable']
  static values = { criteria: { type: String, default: 'present' } }

  connect () {
    this.refresh()
  }

  refresh () {
    const met = this.hasSourceTarget && this.sourceTargets.every(source => this.meets(source))
    this.enableableTargets.forEach(enableable => {
      enableable.disabled = !met
    })
  }

  meets (source) {
    switch (this.criteriaValue) {
      case 'present':
        return this.present(source)
      default:
        throw new Error(`enableable: unknown criteria "${this.criteriaValue}"`)
    }
  }

  present (source) {
    // lexxy specific content accessor
    if (source.matches('lexxy-editor')) return source.isBlank === false
    return (source.value ?? '').trim() !== ''
  }
}
